module.exports = __webpack_public_path__ + "static/typewriter1-e9f61361d068ba2c9a6e4ecd6ad5b664.png";